import { useMutation, useQuery } from 'react-query';
import { listContacts, updateContact, type UpdateContactRequest } from '@/services/contactsService';

export function useContacts(params: { search?: string; tags?: string[]; opt_in?: boolean; page?: number; limit?: number }) {
  return useQuery({
    queryKey: ['contacts', params],
    queryFn: async () => {
      const res = await listContacts(params);
      return res.data;
    },
    enabled: true,
    keepPreviousData: true,
  });
}

export function useUpdateContact() {
  return useMutation({
    mutationFn: async (input: { id: string; payload: UpdateContactRequest }) => {
      const res = await updateContact(input.id, input.payload);
      return res.data;
    },
  });
}
